// SPDX-FileCopyrightText: 2025 Slant Tech LLC
// SPDX-License-Identifier: GPL-3.0-or-later

import { useState } from 'react';

function NewCommentForm({ position, onSubmit, onCancel }) {
  const [body, setBody] = useState('');
  const [componentRef, setComponentRef] = useState(position?.componentRef || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;

    setIsSubmitting(true);
    try {
      await onSubmit(body, componentRef || undefined);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div className="flex items-center gap-2 text-sm text-st-muted font-mono">
        <svg className="w-4 h-4 text-st-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <span>Position: ({position?.x?.toFixed(1)}, {position?.y?.toFixed(1)})</span>
      </div>

      <div>
        <label className="block text-xs font-display font-semibold text-st-muted uppercase tracking-wider mb-1">
          Component Reference (optional)
        </label>
        <input
          type="text"
          value={componentRef}
          onChange={(e) => setComponentRef(e.target.value)}
          placeholder="e.g., R1, U2, C10"
          className="input text-sm"
        />
      </div>

      <div>
        <label className="block text-xs font-display font-semibold text-st-muted uppercase tracking-wider mb-1">
          Comment *
        </label>
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Enter your review comment..."
          className="input text-sm"
          rows={4}
          autoFocus
          required
        />
      </div>

      <div className="flex gap-2">
        <button
          type="submit"
          disabled={!body.trim() || isSubmitting}
          className="btn btn-primary flex-1"
        >
          {isSubmitting ? (
            <div className="spinner w-4 h-4" />
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
              </svg>
              Post Comment
            </>
          )}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="btn btn-secondary"
          disabled={isSubmitting}
        >
          Cancel
        </button>
      </div>

      <p className="text-xs text-st-muted font-body">
        This comment will be synced to the GitLab merge request.
      </p>
    </form>
  );
}

export default NewCommentForm;
